import PropTypes from 'prop-types';
import Modal from 'libs/modal';

const LocalNetworkAccessModal = ({ visible, onClose }) => {
  return (
    <Modal
      visible={visible}
      closable={true}
      modalTitle="Enable Local Network Access"
      confirmBtn={true}
      confirmText="Done"
      cancelBtn={false}
      onSaveBtn={onClose}
      onCancelBtn={onClose}
      className="local-network-access-overlay"
    >
      <div className="local-network-access-modal">
        <p>
          To allow printing to network printers, you need to enable the Local
          Network Access permission in Chrome:
        </p>
        <ol>
          <li>Click the lock/tune icon in Chrome's address bar</li>
          <li>Click "Site settings"</li>
          <li>Find "Local network access" and change it to "Allow"</li>
          <li>Reload the page</li>
        </ol>
      </div>
    </Modal>
  );
};

LocalNetworkAccessModal.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
};

export default LocalNetworkAccessModal;
